import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet-async";
import { AppDispatch } from "../../../../app/store";
import { initiateSelfNominationAction } from "../../slices/getStartedSlice";
import Loader from "../../../../components/Loader";

// Every registrant now enters as a self-nomination. This step automatically
// creates the join session (the backend call that sets up the records keyed by
// joinSessionUuid) and forwards to student details. If a session already exists
// in localStorage we reuse it rather than creating a duplicate.
const StartRegistration: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const isTOLA = process.env.REACT_APP_TOLA === "true";

  useEffect(() => {
    const existingUuid = localStorage.getItem("joinSessionUuid");
    if (existingUuid) {
      navigate("/registration/student-details");
      return;
    }

    dispatch(
      initiateSelfNominationAction(
        { hasConfirmedEligibility: true, isTOLA },
        () => {
          navigate("/registration/student-details");
        },
      ),
    );
  }, [dispatch, navigate, isTOLA]);

  return (
    <>
      <Helmet>
        <title>
          Get Started - National Society of Collegiate Scholars
        </title>
      </Helmet>
      <Loader />
    </>
  );
};

export default StartRegistration;
